// Photo filenames for 20th Anniversary Party
const ANNIVERSARY_PHOTOS_20TH = [
  'rtca0108_31506117611_z.jpg',
  'rtca0109_31622088015_c.jpg',
  'rtca0110_31506117511_c.jpg',
  'rtca0111_31475192712_c.jpg',
  'rtca0112_31622087765_z.jpg',
  'rtca0113_31506118021_z.jpg',
  'rtca0114_30780489344_c.jpg',
  'rtca0115_31506118001_z.jpg',
  'rtca0116_31622088605_z.jpg',
  'rtca0117_30780489234_z.jpg',
  'rtca0118_31506117961_z.jpg',
  'rtca0119_30780489134_c.jpg',
  'rtca0120_31506117911_z.jpg',
  'rtca0130_30780489004_z.jpg',
  'rtca0101_31506117871_z.jpg',
  'rtca0102_31506117841_z.jpg',
  'rtca0103_31622088375_z.jpg',
  'rtca0104_31475193232_z.jpg',
  'rtca0105_31506117691_z.jpg',
  'rtca0106_31622088185_z.jpg',
  'rtca0107_31475193062_c.jpg',
];

export default ANNIVERSARY_PHOTOS_20TH;
